import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider",
  "use": "icon-slider-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-slider\"><defs><style></style></defs><path d=\"M951.453 476.844H523.672a131.836 131.836 0 00-254.18 0H72.547v70.312h196.945a131.836 131.836 0 00254.18 0h427.781z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol